import $ from "jquery";

const init = () => {
  initSlider();
};

const initSlider = () => {
  $(".usp-container").slick({
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 2500,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    centerMode: true,
    cssEase: "linear",
    pauseOnFocus: false,
    pauseOnHover: false,
  });
};

try {
  init();
} catch (error) {
  console.log(error);
}
